import { render, staticRenderFns } from "./editCustom.vue?vue&type=template&id=2b0a54d4&"
import script from "./editCustom.vue?vue&type=script&lang=ts&"
export * from "./editCustom.vue?vue&type=script&lang=ts&"
import style0 from "./editCustom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports